import { LocaleTypes } from '@i18n';

import { HeaderData, HeaderNavContext } from '../interfaces';

import getProjectName from './getProjectName';

const buildHeaderNavContext = (
    isAuth: boolean,
    locale: LocaleTypes,
    data?: HeaderData,
): HeaderNavContext => ({
    isAuth,
    project: getProjectName(),
    locale,
    userProfile: data?.userProfile ?? null,
    taxData: data?.taxData ?? null,
    manager: data?.manager ?? null,
    runtime: {
        supportUnreadCount: data?.supportUnreadCount ?? 0,
    },
});

export default buildHeaderNavContext;
